import { polyfills } from './polyfills/polyfills';
import '../styles/main.scss';
import whatInput from 'what-input';
import 'a11y-toggle';
import LazyLoad from 'vanilla-lazyload';
import { lazyLoadSettings } from './modules/lazyload-settings';
import menu from './modules/menu';
import dataSheets from './modules/datasheets';
import overlay from './modules/overlay';
import { splide } from './modules/splide';
import { video } from './modules/video';
import contactdropdown from './modules/contactdropdown';
import market from './modules/market';
import pagination from './modules/pagination';
import mobileMenu from './modules/mobile-menu';
import { toggleButton } from './modules/toggle-button';
import cookiebot from './modules/cookiebot';
import reCaptca from './modules/recaptcha';
import tracking from './modules/tracking';

const start = () => {
  console.log('App loaded!');
  cookiebot.init();
  const lazyLoad = new LazyLoad(lazyLoadSettings);
  document.querySelector('.js-menu-bar') ? menu() : null;
  dataSheets();
  overlay();
  splide.init();
  video('.js-c-video');
  contactdropdown();
  pagination();
  toggleButton();
  market();
  mobileMenu('.js-hamburger');
  reCaptca();
  tracking.init();
};

export const app = () => {
  if (!polyfills) {
    start();
  } else {
    Promise.all([...polyfills])
      .then(_ => {
        try {
          start();
        } catch (error) {
          console.error('Failed to start the app', error);
        }
      })
      .catch(error => {
        console.error('Failed fetching polyfills', error);
      });
  }
};

// eslint-disable-next-line no-unused-expressions
document.readyState !== 'loading'
  ? app()
  : document.addEventListener('DOMContentLoaded', app);
